import { default as axios } from 'axios';
import { API_BASE_URL } from '../envConfig.js';
export const client = createAxiosClient({
    options: {
        baseURL: `${API_BASE_URL}/api/tenant-onboarding/admin/v1`,
        timeout: 30000,
        withCredentials: true,
    },
});
function createAxiosClient({ options }) {
    const client = axios.create(options);
    client.interceptors.response.use((response) => response, (error) => {
        var _a;
        const payload = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
        if (payload && typeof payload.code === 'string') {
            return Promise.reject(payload);
        }
        return Promise.reject(error);
    });
    return client;
}
